import { Box, Image } from '@chakra-ui/react';
import React from 'react'
import { useContext } from 'react';
import GitHubCalendar from 'react-github-calendar';
import { context } from '../utility/ContextProvider';
const GithubNew = () => {
  const { textcolour } = useContext(context);

  return (
    <section className="section feature" id="featured">
    <div className="container">
      <h2 className="headline headline-2 section-title">
        {" "}
        My Github <span className="span">Stats</span>
      </h2>
      <p className="section-text">Days I code</p>
      <GitHubCalendar  className={`react-activity-calendar github`}
      username="dishagup"
      blockSize={15}
      blockMargin={5}
      color={textcolour}
      fontSize={16}
    />
    <br/>
        <p className="section-text">My contributions</p>
        <Box align='center'  className='github2'>
<Image id='github-streak-stats' w={{base:'88%',md:'70%',xl:"65%"}} src='https://github-readme-streak-stats.herokuapp.com?user=dishagup&theme=aura' />
 </Box>
 <br /> 
 
 <br />
 

        <p className="section-text">Top Languages</p>
        <Box align='center' className='github' >
<Image id='github-top-langs'  w={{base:'80%',md:'60%',xl:"55%"}} src='https://github-readme-stats.vercel.app/api/top-langs/?username=dishagup&layout=compact&theme=aura' />
 </Box>
        <p className="section-text">Stats card</p>
        <Box  align='center' className='github2'  >
<Image id='github-stats-card'  w={{base:'85%',md:'65%',xl:"60%"}} src='https://github-readme-stats.vercel.app/api?username=dishagup&show_icons=true&theme=aura' />
 </Box>
    </div>
  </section>
  )
}

export default GithubNew